module.exports = __webpack_public_path__ + "img/check-fill-green.67ad7802.svg";